/**
 * @generated SignedSource<<3c28b1c623e4a442c01d9f8aff1c0e2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductRole = "instructor" | "manager" | "member" | "%future added value";
export type UpdateProductMembershipInput = {
  id: string;
  isHiddenFromNav?: boolean | null;
  isLearnMode?: boolean | null;
  role?: ProductRole | null;
};
export type UpdateProductRoleButtonMutation$variables = {
  input: UpdateProductMembershipInput;
};
export type UpdateProductRoleButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly productMembership: {
      readonly id: string;
      readonly role: ProductRole;
    } | null;
  };
};
export type UpdateProductRoleButtonMutation = {
  response: UpdateProductRoleButtonMutation$data;
  variables: UpdateProductRoleButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProductMembershipResponse",
    "kind": "LinkedField",
    "name": "updateProductMembership",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductMembership",
        "kind": "LinkedField",
        "name": "productMembership",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateProductRoleButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateProductRoleButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a92be2cf5d0eb1115742b66e6013fa44",
    "id": null,
    "metadata": {},
    "name": "UpdateProductRoleButtonMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateProductRoleButtonMutation(\n  $input: UpdateProductMembershipInput!\n) {\n  response: updateProductMembership(input: $input) {\n    productMembership {\n      id\n      role\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bb41d230c3664bbafc57b78a4fce6c4";

export default node;
